import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ILessonNavigation } from '@/shared/types/lesson';
import { Section } from '@/shared/ui/Section';
import { LessonChip } from '../LessonChip';

type LessonChipState = 'completed' | 'current' | 'upcoming';

type LessonChipData = ILessonNavigation & {
  state: LessonChipState;
};

interface LessonProgressBarProps {
  lessons: ILessonNavigation[];
  currentLessonOrder: number;
  buildLessonLink: (lesson: ILessonNavigation) => string;
}

export const LessonProgressBar = ({
  lessons,
  currentLessonOrder,
  buildLessonLink,
}: LessonProgressBarProps) => {
  const chips = useMemo(() => {
    const sorted = [...lessons].sort((a, b) => a.order - b.order);

    return sorted.map((l): LessonChipData => {
      const isCurrent = l.order === currentLessonOrder;
      const state: LessonChipState = isCurrent
        ? 'current'
        : l.isCompleted
          ? 'completed'
          : 'upcoming';

      return { ...l, state };
    });
  }, [lessons, currentLessonOrder]);

  return (
    <Section>
      <div className="overflow-x-auto" role="list" aria-label="Lessons progress">
        <div className="inline-flex gap-2 p-2">
          {chips.map((el) => {
            const to = buildLessonLink(el);
            return (
              <Link key={to} to={to} role="listitem" title={el.title}>
                <LessonChip order={el.order} state={el.state} />
              </Link>
            );
          })}
        </div>
      </div>
    </Section>
  );
};
